/* eslint-disable react-hooks/exhaustive-deps */
import { useQuery, useSubscription } from "@apollo/client";
import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { GET_CHANNELS } from "../../Apollo/graphql/Query";
import { useStoreActions, useStoreState } from "../../myStore";
import Dashboard from "../../Screen/Dashboard/Dashboard/Dashboard";
import { NEW_MESSAGE_SUBSCRIPTION } from "../../Apollo/graphql/Subscription/NewMessageSubscription";
import { getUserId } from "../../utils/utilsFunctions";

const UserDashboardRoute = (props: any) => {
  return (
    <Switch>
      <Route path="/dashboard" component={Dashboard} />
    </Switch>
  );
};

function ProtectedRoutes(): any {
  const setChannels = useStoreActions((actions) => actions.chat.setChannels);
  const channels = useStoreState((state: any) => {
    return state.chat.channels;
  });

  useQuery(GET_CHANNELS, {
    onCompleted: (data: any) => {
      setChannels(data.channels || []);
    },
    onError: (err) => {
      console.log("couldnt fetch channel", err);
    },
  });

  const { data: chatDataSubscription, error: chatErrorSubscription } =
    useSubscription(NEW_MESSAGE_SUBSCRIPTION);

  useEffect(() => {
    if (chatErrorSubscription) console.error(chatErrorSubscription);

    if (chatDataSubscription) {
      const message = chatDataSubscription.newMessage;
      const channelsCopy = [...channels];
      const channelIndex = channelsCopy.findIndex(
        (c) => c._id === message.channelId
      );
      if (getUserId() !== message.senderId) {
        console.log("--send notification--");
      }
      if (channelIndex >= 0) {
        const newChannel = {
          ...channelsCopy[channelIndex],
          messages: channelsCopy[channelIndex].messages
            ? [message, ...channelsCopy[channelIndex].messages]
            : null,
          latestMessage: message,
        };
        channelsCopy[channelIndex] = newChannel;
      } else {
        const newChannel = {
          ...message.channel,
          messages: [message],
          latestMessage: message,
        };
        channelsCopy.unshift(newChannel);
      }
      setChannels(channelsCopy);
    }
  }, [chatDataSubscription, chatErrorSubscription]);

  return (
    <UserDashboardRoute />
  );
}

export default ProtectedRoutes;
